module.exports = __webpack_public_path__ + "img/goals.9e738724.svg";